import { Vector3, MathUtils } from 'three';

import IPlacement from '../interfaces/IPlacement3d';
import Placement3d from './Placement3d';
import IProduct from '../interfaces/IProduct';
import productSchema from '../services/bimVisualizerApi/schema/productSchema';

import Representation2d from './representation2d/Representation2d';
import RepresentationFactory from './RepresentationFactory';
import {buildFillingRepresentation} from './representation2d/FillingSymbolFactory/FillingSymbolFactory';

import Representation3d from './representation3d/Representation3d';
import { ElementTypeEnum, getElementTypeFromString } from '../elementTypeMappings';

import ProductData from './productData/ProductData';
import { buildProductData } from './productData/ProductDataFactory';
import { getScaledVector3 } from '../utils/scaler';
import { UUID } from '../utils/typeDefinitions';

class HeightInterpolation
{
    min: number;
    max: number;

    constructor(heights: number[])
    {
        this.min = Math.min(...heights);
        this.max = Math.max(...heights);
    }

    interpolateHeight(t: number) {
        return MathUtils.lerp(this.min, this.max, t);
    };
}

export default class Product implements IProduct
{
    globalId: string;
    name: string;
    placement: IPlacement;
    dimensions: Vector3 | undefined;

    representations2d: Representation2d[] = [];
    representations3d: Representation3d[] = [];

    productData: ProductData;

    children: Product[] = [];

    parent: Product | null = null;

    constructor(globalId: UUID, name: string, placement: IPlacement, productData: ProductData) {
        this.globalId = globalId;
        this.name = name;
        this.placement = placement;
        this.productData = productData;
    }

    getTopHeight = () => this.placement.location.z + (this.dimensions?.z ?? 0.0);

    static fromJSON(json: any, parent: Product | null): Product {

        const parsed = productSchema.parse(json); 
        
        const p = new Product(  parsed.globalId,
                                parsed.name,
                                Placement3d.fromJSON(parsed.placement),
                                buildProductData(parsed.productData)
                            );
        
        p.dimensions = parsed.dimensions 
                            ? getScaledVector3(parsed.dimensions)
                            : undefined;

        p.representations3d = parsed.representations3d.map((r: any) => RepresentationFactory.createRepresentation3d(r.representationType, r));
        p.parent = parent;
        p.children = parsed.children.map((c: any) => Product.fromJSON(c, p));

        /* const fixtures = p.children.filter(c => c.productData.productType === ElementTypeEnum.Fixture);
        const interpolator = new HeightInterpolation( fixtures.map(p => p.getTopHeight() ));
         */
        if (p.productData.productType === ElementTypeEnum.Door || p.productData.productType === ElementTypeEnum.Window) {
            const dimensions = p.dimensions || getScaledVector3({x:800, y:100, z:2100});

            p.representations2d = [buildFillingRepresentation(p.productData, dimensions.x, dimensions.y)];
        }
        else
            p.representations2d = parsed.representations2d.map((r: any) => RepresentationFactory.createRepresentation2d(r.representationType, r));
        
        
        return p;
    }
}

